import React, { useState, useEffect, useRef } from "react";
import { ProgressSpinner } from 'primereact/progressspinner';
import ApiServices from "../../service/api/ApiServices";
import { Toast } from "primereact/toast";

import { Chart } from 'primereact/chart';

const saved = localStorage.getItem("user");


// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class th   at handles API requests.
const apiServices = new ApiServices()

/** * SalesPersonStats component to display a list of SalesPersonStats in a data table.
 * It fetches the SalesPersonStats data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the SalesPersonStats based on their names or other attributes.
 */
export const SalesPersonStats = (props) => {

    const [loading, setLoading] = useState(false)
    const [chartLabels, setChartLabels] = useState([])
    const [orders, setOrders] = useState([])
    const [sales, setSales] = useState([])

    // constant values


    const toast = useRef(null);

    useEffect(() => {
        getSalesPersonStats(props?.daywiseStats);
    }, [props?.daywiseStats])

    /**
     * Function to fetch SalesPersonStats data from the API
     * and update the state with the fetched data.
     */
    const getSalesPersonStats = async (dayWiseCData) => {
        setLoading(true)
        const orders = dayWiseCData.map((x) => { return x.totalOrders })
        const sales = dayWiseCData.map((x) => { return x.totalAmount })
        const label = dayWiseCData.map((x) => { return x._id })
        setOrders(orders || [])
        setSales(sales || [])
        setChartLabels(label || [])
        setLoading(false)
    }

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    // Create a ref for the toast component to show notifications.

    const stackedData = {
        labels: chartLabels,
        datasets: [
            {
                type: 'bar',
                label: 'Orders',
                backgroundColor: '#07564E',
                data: orders,
                borderRadius: 10
            },
            {
                type: 'bar',
                label: 'Sales',
                backgroundColor: '#28877D',
                data: sales,
                borderRadius: 10
            }
        ]
    };

    const stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: textColor
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                },
                title: {
                    display: true,
                    text: 'Date'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                },
                title: {
                    display: true,
                    text: "Orders & Sales"
                }
            }
        },
        onClick: function (e, clickedElement) {
            // getRequiredData(clickedElement)
        }
    };

    return (

        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <Toast ref={toast} position="center" />
                        {
                            loading ?
                                <>
                                    <div className="spinner-div">
                                        <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                    </div>
                                </>
                                :
                                <>
                                    <Chart type="bar" data={stackedData} options={stackedOptions} />
                                </>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}